module.exports = __webpack_public_path__ + "static/img/banner_indi.49d1cc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/banner_indi.png
// module id = XX/I
// module chunks = 2